import { Dialog, Transition } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { CSSProperties, FC, Fragment, ReactNode } from 'react'

import { cn } from '@/app/utils'

export type Props = {
  children?: ReactNode
  opened: boolean
  onClose: () => void
  className?: string
  style?: CSSProperties
  notClosable?: boolean
  overlayClassName?: string
  closeButtonClassName?: string
  closeButtonIconClassName?: string
  contentClassName?: string
}

const PreviewModal: FC<Props> = ({
  children,
  opened,
  onClose,
  className,
  style,
  notClosable,
  overlayClassName,
  closeButtonClassName,
  closeButtonIconClassName,
  contentClassName
}) => {
  return (
    <Transition appear show={opened} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-50"
        onClose={() => !notClosable && onClose()}
      >
        <Transition.Child>
          <div className={cn('fixed inset-0 bg-black/80', overlayClassName)} />
        </Transition.Child>

        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          {!notClosable && (
            <button
              title="Закрыть"
              aria-label="Закрыть модальное окно"
              className={cn(
                'absolute right-0 top-0 ml-auto flex h-40 w-40 items-center justify-center p-8 transition-colors xs:p-4',
                'xs:h-28 xs:w-28',
                {
                  'pointer-events-none invisible opacity-0': notClosable
                },
                closeButtonClassName
              )}
              onClick={() => !notClosable && onClose()}
            >
              <XMarkIcon
                className={cn('h-24 w-24 text-white', closeButtonIconClassName)}
              />
            </button>
          )}
          <Transition.Child>
            <Dialog.Panel
              className={cn(
                'relative max-h-[90vh] max-w-[90vw]',
                'bg-transparent shadow-none',
                className
              )}
              style={style}
            >
              <div
                className={cn(
                  'flex items-center justify-center',
                  contentClassName
                )}
              >
                {children}
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  )
}

export { PreviewModal }
